/**
 * @see https://tahazsh.com/vuebyte-change-page-title
 */

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}

import { mapGetters } from "vuex";

export default {
  created() {
    const title = getTitle(this);
    if (title) {
      this.$store.dispatch("pageTitleChange", title);
    }
  },

  computed: {
    ...mapGetters({
      pageTitle: "pageTitle"
    })
  }
};
